module.exports = __webpack_public_path__ + "media/svg/entry-sheets-selected-d2cb0401.svg";